import React from 'react';

function News() {
  return (
    
  <>
    <div className="col-lg-4">
      <h1>VAT News</h1>
    </div >
  </>

        );
}

export default News;